<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner
            :animation-duration="2000"
            :size="80"
            color="#63c2de"
            class="offset-6"
          >Entrar</semipolar-spinner>
        </div>
        <table-adsets
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fab fa-adversal mr-2'></i> Conjunto de campañas</h4>"
          v-else
        >
        </table-adsets>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableAdsets from "./TableAdsets.vue";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "tables",
  components: { TableAdsets, SemipolarSpinner },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre de conjunto", sortable: true },
        { key: "status", label: "Estado", sortable: true },
        {key:"acciones",label:"Acciones"}
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getAdsets();
  },
  methods: {
    getAdsets() {
      var adsets = store.getters.getAdsets;
      if (adsets.length == 0) {
        this.isLoading = true;
        store.dispatch("getAdsets").then(() => {
          var adsets = store.getters.getAdsets;
          shuffleArray([adsets]);
          this.isLoading = false;
          this.items = adsets;
          this.itemsArray = adsets;
        });
      } else {
        shuffleArray([adsets]);
        this.items = adsets;
        this.itemsArray = adsets;
      }
    }
  }
};
</script>
